import { Vault } from '@/features/vaults/types';

export const bscCycleNetworkVaultId = 'bsc-cyclenetwork-vault';

export const bscCycleNetworkVault: Vault = {
  id: bscCycleNetworkVaultId,
  type: 'multi-vault',
  name: 'CycleNetwork Vault',
  description:
    'Cycle Network is a bridgeless all-chain settlement layer with 400M TVL, 2.7M+ mainnet Txs, and 680K+ fans. Backed by Vertex Ventures and Incubated by YZi Labs, it powers 100+ use cases via Cycle SDK, Piggy Bank, and Golden Goose.',
  category: 'restaking',
  address: '0xc8e046fe778BE29572016d1f703e9B2ff77a207D',
  compatibility: 'ERC4626',
  interop: {
    type: 'layer-zero',
    sourceCore: '0xc8e046fe778BE29572016d1f703e9B2ff77a207D',
    targetCore: '0xAdEcB7647C3370A40c9F06FB8F5F709c87324932',
    targetNetwork: 'ethereum',
    targetAddress: '0x8Eb26Ae16ceD27f46c717d0E2dF070c370d65261',
    sourceWithdrawalQueue: '0xaC345625fD4C1086Bb9141099e250C34694Ef10E',
  },
  curators: ['cyclenetwork'],
  operator: [],
  points: [
    { entity: 'mellow', startTimestamp: 1738573595 },
    { entity: 'symbiotic', startTimestamp: 1738573595 },
  ],
  layer: 'Symbiotic',
  network: 'bsc',
  depositTokens: [
    {
      address: '0x5845684b49aEf79A5c0F887f50401C247dca7AC6',
      decimals: 18,
      symbol: 'CYC',
    },
  ],
  baseToken: '0x5845684b49aEf79A5c0F887f50401C247dca7AC6',
  lpTokenSymbol: 'CYC',
  lpTokenDecimals: 18,
  withdrawDuration: 1296000,
  withdrawDurationDisplay: '15 days',
  tokenRewards: [
    {
      token: {
        network: 'bsc',
        symbol: 'CYC',
        address: '0x5845684b49aEf79A5c0F887f50401C247dca7AC6',
        decimals: 18,
      },
      startTimestamp: 1745445600,
      startClaimTimestamp: 1745964000,
    },
  ],
  allocations: {
    showAllocationsTab: true,
  },
};
